export default function WhatsInSetSection() {
  return (
    <section className="bg-[#6B1E3B] py-16 md:py-28 lg:py-32">
      <div className="w-full px-4 md:px-8 lg:px-12">
        {/* Eyebrow */}
        <p className="text-[#C9A84C] text-xs font-body tracking-[0.25em] uppercase mb-4 text-center">
          What is inside
        </p>

        {/* Headline */}
        <h2 className="font-heading text-xl md:text-3xl lg:text-5xl text-[#FDFAF8] text-center mb-14 leading-tight">
          Two tools. One complete healing practice.
        </h2>

        {/* Two panels */}
        <div className="grid grid-cols-1 md:grid-cols-2 gap-6 md:gap-12 max-w-5xl mx-auto">
          {/* Left — The Journal */}
          <div className="bg-[#FDFAF8]/10 backdrop-blur-sm border border-[#C9A84C]/30 rounded-lg p-6 md:p-10">
            <div className="w-12 h-12 flex items-center justify-center mb-6">
              <i className="ri-book-open-line text-3xl text-[#C9A84C]" />
            </div>
            <h3 className="font-heading text-xl md:text-2xl text-[#FDFAF8] mb-4">
              The Journal
            </h3>
            <p className="font-body text-sm text-[#E8E8E8] leading-relaxed mb-4">
              A structured, clinically informed healing journal. 4 phases, 12 weeks of guided prompts, generous reflection space.
            </p>
            <p className="font-body text-sm text-[#E8E8E8] leading-relaxed">
              Daily affirmations, mood tracker, and art pages included.
            </p>
          </div>

          {/* Right — The Card Deck */}
          <div className="bg-[#FDFAF8]/10 backdrop-blur-sm border border-[#C9A84C]/30 rounded-lg p-6 md:p-10">
            <div className="w-12 h-12 flex items-center justify-center mb-6">
              <i className="ri-stack-line text-3xl text-[#C9A84C]" />
            </div>
            <h3 className="font-heading text-xl md:text-2xl text-[#FDFAF8] mb-4">
              The Card Deck
            </h3>
            <p className="font-body text-sm text-[#E8E8E8] leading-relaxed mb-4">
              52 beautifully designed cards across 4 healing phases. Illustrated with Black women.
            </p>
            <p className="font-body text-sm text-[#E8E8E8] leading-relaxed">
              Pull one every morning. Use one to open your journal session. Draw one when you feel lost or disconnected.
            </p>
          </div>
        </div>

        {/* Centered italic line */}
        <div className="text-center mt-14">
          <p className="font-quote text-base md:text-lg italic text-[#C9A84C]">
            The journal takes you deep. The cards bring you back. Together, they are everything.
          </p>
        </div>
      </div>
    </section>
  );
}